import Vue from "vue"

import d2Container from "./d2-container"
import authButton from "./d2-auth/d2-auth-btn.js"

// 注意 有些组件使用异步加载会有影响
Vue.component("D2Container", d2Container)
Vue.component("D2Icon", () => import("./d2-icon"))
Vue.component("D2ElIcon", () => import("./d2-el-icon"))
Vue.component("D2IconSvg", () => import("./d2-icon-svg/index.vue"))
Vue.component("D2TableHeader", () => import("./d2-table-header/index.vue"))
Vue.component("D2Table", () => import("./d2-table/index.vue"))
Vue.component("D2Dialog", () => import("./d2-dialog/index.vue"))
Vue.component("D2Form", () => import("./d2-form/index.vue"))
Vue.component("D2Search", () => import("./d2-search/index.vue"))
Vue.component("RelateStoreDialog", () =>
  import("./d2-form/relateStoreDialog.vue")
)
Vue.component("BaseDialog", () => import("./baseDialog/index.vue"))
Vue.component("GlsxCombiForm", () => import("./glsx-combi-form/index.vue"))
Vue.component("GLDialog", () => import("./GLDialog/index.vue"))
// Vue.component([authButton.name], authButton)
Vue.component(authButton.name, authButton)
